/* Monetize4U — comportamiento de las secciones m4u-*. Sin dependencias. */
(function () {
  if (window.__m4u) return; window.__m4u = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al hacer scroll */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  const observeReveal = (root) => root.querySelectorAll('[data-reveal]').forEach((el, i) => {
    if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', (Math.min(i, 8) * 70) + 'ms');
    io.observe(el);
  });

  /* Contadores */
  const counters = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return; counters.unobserve(e.target);
      const el = e.target, end = parseFloat(el.dataset.count), suffix = el.dataset.suffix || '';
      if (reduce) { el.textContent = end + suffix; return; }
      const t0 = performance.now(), dur = 1100;
      const tick = (t) => { const p = Math.min(1, (t - t0) / dur), v = Math.round(end * (1 - Math.pow(1 - p, 3))); el.textContent = v + suffix; if (p < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });

  /* Brillo que sigue al cursor en tarjetas */
  const glow = (root) => root.querySelectorAll('.glow-card').forEach((c) => {
    c.addEventListener('pointermove', (ev) => { const r = c.getBoundingClientRect(); c.style.setProperty('--mx', (ev.clientX - r.left) + 'px'); c.style.setProperty('--my', (ev.clientY - r.top) + 'px'); });
  });

  /* Portadas del hero: parallax con el ratón y flotación */
  const hero = (root) => root.querySelectorAll('[data-hero-stage]').forEach((stage) => {
    const cards = stage.querySelectorAll('[data-depth]');
    if (reduce) return;
    let rx = 0, ry = 0, tx = 0, ty = 0;
    stage.addEventListener('pointermove', (ev) => { const r = stage.getBoundingClientRect(); tx = ((ev.clientX - r.left) / r.width - .5); ty = ((ev.clientY - r.top) / r.height - .5); });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; });
    const loop = () => { rx += (tx - rx) * .06; ry += (ty - ry) * .06; cards.forEach((c) => { const d = parseFloat(c.dataset.depth); c.style.transform = `translate3d(${rx * 26 * d}px, ${ry * 18 * d}px, 0) rotate(${c.dataset.rot || 0}deg)`; }); requestAnimationFrame(loop); };
    loop();
  });

  /* Fases: pestañas */
  const phases = (root) => root.querySelectorAll('[data-phases]').forEach((box) => {
    const tabs = box.querySelectorAll('[data-tab]'), panels = box.querySelectorAll('[data-panel]');
    const go = (i) => { tabs.forEach((t, k) => t.classList.toggle('is-on', k === i)); panels.forEach((p, k) => p.classList.toggle('is-on', k === i)); box.style.setProperty('--progress', ((i + 1) / tabs.length * 100) + '%'); };
    tabs.forEach((t, i) => { t.addEventListener('click', () => { go(i); box.dataset.paused = '1'; }); t.addEventListener('mouseenter', () => go(i)); });
    go(0);
    if (!reduce) { let i = 0; setInterval(() => { if (box.dataset.paused) return; i = (i + 1) % tabs.length; go(i); }, 3200); }
  });

  /* FAQ: uno abierto a la vez */
  const faq = (root) => root.querySelectorAll('[data-faq]').forEach((list) => {
    list.querySelectorAll('details').forEach((d) => d.addEventListener('toggle', () => { if (d.open) list.querySelectorAll('details[open]').forEach((o) => { if (o !== d) o.open = false; }); }));
  });

  /* CTA fija en móvil: aparece pasado el hero y desaparece en la sección de compra */
  const sticky = () => {
    const bar = document.querySelector('.m4u-sticky'); if (!bar) return;
    const heroEl = document.querySelector('[data-hero-stage]')?.closest('section'), buy = document.getElementById('metodos');
    const update = () => {
      const pastHero = heroEl ? heroEl.getBoundingClientRect().bottom < 0 : window.scrollY > 500;
      const inBuy = buy ? (buy.getBoundingClientRect().top < window.innerHeight * .6 && buy.getBoundingClientRect().bottom > 120) : false;
      bar.classList.toggle('is-on', pastHero && !inBuy);
    };
    addEventListener('scroll', update, { passive: true }); update();
  };

  /* El cursor a medida se quitó el 13/09/2026 (está en el historial de git si hace
     falta recuperarlo). Era un punto pegado al puntero y un aro que lo seguía con
     un retraso del 18 % por fotograma. El retraso no era un fallo: era el efecto,
     así que no había forma de «quitarle el lag» y conservar el aro.

     Se quita por tres razones, y ninguna es estética:
       1. El puntero del sistema ya dice qué se puede pulsar. Un aro que llega
          tarde compite con esa señal justo cuando alguien va a hacer clic.
       2. mix-blend-mode: difference sobre un elemento fijo a pantalla completa
          obliga al navegador a recomponer en cada movimiento del ratón. En un
          portátil modesto eso se nota, y se nota más cuanto peor es el equipo.
       3. Esta portada va a recibir tráfico de pago. Un adorno que estorba en el
          momento del clic se paga en euros. */

  const init = (root) => { observeReveal(root); root.querySelectorAll('[data-count]').forEach((el) => counters.observe(el)); glow(root); hero(root); phases(root); faq(root); };
  const boot = () => { init(document); sticky(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* El editor de temas vuelve a montar secciones: re-inicializar */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
